import BigNumber from 'bignumber.js';

import { DlVault } from 'types/contracts';

export interface GetHKTPriceInput {
  dlVaultContract: DlVault;
  accountAddress: string;
}

export type GetHKTPriceOutput = {
  hktPrice: BigNumber;
};

const getHKTPrice = async ({
  dlVaultContract,
  accountAddress,
}: GetHKTPriceInput): Promise<GetHKTPriceOutput> => {
  const res = await dlVaultContract.methods
    .getHKTPrice()
    .call();

  return {
    hktPrice: new BigNumber(res),
  };
};

export default getHKTPrice;
